import getWorkflowWithActions from './WorkflowWithActions';
export default getWorkflowWithActions;